export default "__VITE_ASSET__Cn_rgO3H__"